/**
 * 服务端版本探针：`GET /api/health` 的 `version`（契约 §25、`05-ui-design-system.md` §5.6）。
 *
 * **为什么用裸 `fetch` 而不是 `lib/apiClient`**：
 *   ① 端点是**公开**的（`health.controller.ts` 不挂任何守卫，编排的 healthcheck 拿不到令牌），
 *      启动期也**还没有会话** —— 走带鉴权的客户端会在未登录时先撞 401；
 *   ② 走 `apiClient` 会把这次探活卷进 401 单飞刷新那条链路（`refreshPromise`），
 *      一个只读的版本探针不该有能力触发令牌轮换；
 *   ③ 探针必须**能在没有会话、没有 401 处理、没有 axios 的环境里失败** ——
 *      失败在这里是**正常结果**（见 `useSwUpdate` 的 catch），不是异常路径。
 *
 * **读不出 `version` 一律抛**（而不是回一个空串）：空串与任何真实构建版本都不相等，
 * 会立刻把「探活成功但响应格式不对」伪装成「有新版本」，让店员看到一条永远点不掉的提示。
 * 抛出去之后 `useSwUpdate` 会静默 —— 「探活失败不是更新信号」。
 */
const HEALTH_PATH = '/api/health';

export async function fetchServerVersion(): Promise<string> {
  const response = await fetch(HEALTH_PATH, {
    headers: { accept: 'application/json' },
    cache: 'no-store',
  });
  if (!response.ok) {
    throw new Error(`GET ${HEALTH_PATH} 返回 ${response.status}`);
  }
  const body: unknown = await response.json();
  if (typeof body !== 'object' || body === null) {
    throw new Error(`GET ${HEALTH_PATH} 的响应不是对象`);
  }
  const version = (body as { version?: unknown }).version;
  if (typeof version !== 'string' || version === '') {
    throw new Error(`GET ${HEALTH_PATH} 的响应没有 version`);
  }
  return version;
}
